<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style"; 
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import inventory_miAPI from "@/services/standards/inventory_mi/inventory_miAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Pagination from "@/components/standard/inventory_mi/inventoryPagination";
import ScoreAPI from "@/services/standards/score/scoreAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist"
import puntuationAPI from "@/services/standards/puntuation/puntuationAPI";

/**
 * Form elements component
 */
export default { 
  page: {
    title: "Editar",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DontExist,
  },
  data() {
    
    return {
      title: "Editar Puntuación",
       items: [
       
        {
          text: "Configuración",
          href: "/forms/configuracion",
        },
        {
          text: "Editar Puntuación",
          active: true,
        },
      ],
       

      lista:[ ],
      loading: true,

      item: null,
      itemStatus: null,

      itemData: null,

      puntuation: {
        
        puntation_relative: null,
        puntation_absoluta: null,
        operation: null,
        status: null,
        items_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
       
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      
    

     
    };
  }, 
  methods: {

    getItemData() {
      ItemAPI.getItems(49)
        .then((response) => {
          console.log("Item: ", response);
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },



    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },
    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {

CompanyItemsAPI.getStatus(this.companyID, 49)
  .then(response => {
    this.item = response || null
    this.itemStatus = response.status ? response.status : null
    console.log(`This is the item ${this.item ? this.item.items_id : null}: `, this.item)
  })
  .catch(error => {
    console.log(error)
  })
},

    changeItemStatus(item, itemStatus) {

console.log(item, itemStatus)

if (item) {

  const itemChange = {
          items_id: item.items_id,
          status: itemStatus,
          operation: item.operation,
          puntation_absoluta: item.puntation_absoluta,
          puntation_relative: item.puntation_relative,
        }

  console.group('Data that will be updated')
  console.log('New item status: ', itemChange)
  console.log('CompanyID: ', this.companyID)
  console.groupEnd()

  CompanyItemsAPI.updateStatus(this.companyID, itemChange)
    .then(response => {
      console.log(response)

      if (
              response.message ===
                "item actualizado con exito, se ha sumado el valor del item , en la puntuacion" ||
              response.message === "item actualizado con exito"
            ) {
              Swal.fire({
                title: "¡Se ha actualizado el estado del ítem con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            } else {
              Swal.fire({
                title: "No se ha podido actualizar el estado del ítem",
                type: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }

    })
    .catch(error => {
      console.log(error)
    })

}

},
 
 /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
     getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then(response => {
          item = response || null
          itemStatus = response.status
          console.log(`This is the item ${item ? item.items_id : null}: `, item)
        })
        .catch(error => {
          console.log(error)
        })
    },



     /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action 
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty
        
        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged
      
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

      /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    

    getPuntuation() {
      puntuationAPI.get(this.$route.params.id)
        .then((response) => {
          
          console.log(response, 'respuesta');
          this.puntuation = {   
            puntation_relative: response.puntation_relative, 
            puntation_absoluta: response.puntation_absoluta,
            operation: response.operation,
            status: response.status, 
            companies_id: response.companies_id,
            items_id: response.items_id,
           
          };
          this.loading= false;
          console.log(this.puntuation)

        })
        .catch((error) => {
          console.log(error);
        });
    }, 

    update() {
       console.log(this.puntuation);
       puntuationAPI.updatePuntuation(this.$route.params.id, {
         
        puntation_relative: this.puntuation.puntation_relative, 
        puntation_absoluta: this.puntuation.puntation_absoluta,
        operation: this.puntuation.operation,
        status: this.puntuation.status, 
        companies_id: this.puntuation.companies_id,
        items_id: this.puntuation.items_id,
        
          
        }) 
        .then((response) => {
          
          Swal.fire({
                title: "¡Informacion actualizada con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
         this.$router.go(-1);
          console.log(response);
        });
    },


  
     
  },

  mounted() {
  this.getPuntuation()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if=" !loading && classificationID <= 4 ">  
        <div class="card">
          <div class="card-body">
             <div class="row">
              <div class="col-md-6 col-sm-12">


</div>
            
<div class="form-row col-md-6 col-sm-12 pt-1">
               
                </div>
              
             
            </div>

        

            
            

            <form class="form-group" @submit.prevent="update">
              <div class="form-row pt-3">

              

                <b-form-group class="col-md-6" label="Puntación relativa" label-for="employee">
                  <b-form-input  type="text" id="code" v-model="puntuation.puntation_relative" placeholder=""></b-form-input>
                  </b-form-group>

           
                  <b-form-group class="col-md-6" label="Puntuación absoluta" label-for="employee">
                    <b-form-input  type="text" id="name"  v-model="puntuation.puntation_absoluta" placeholder=""></b-form-input>
                  </b-form-group>
                
                  
                  
                  
                    
                   
              </div>

              <div class="form-row">

              
              <b-form-group class="col-md-6" label="Operación" label-for="hora">
                <b-form-input  type="text" id="model" v-model="puntuation.operation" placeholder=""></b-form-input>
              </b-form-group>
              <b-form-group class="col-md-6" label="Estado" label-for="employee">
                    <select id="employeeID" class="form-control" v-model="puntuation.status" >
                      <b-form-select-option value="Aprobado" >
                       Aprobado
                      </b-form-select-option>
                      <b-form-select-option value="Pendiente">
                       Pendiente
                      </b-form-select-option>
                      <b-form-select-option value="No cumplido">
                       No cumplido
                      </b-form-select-option>
                    </select>
                  </b-form-group>
              </div>

              <div class="form-row">
                <b-form-group class="col-md-6" label="ID de la compañia" label-for="hora">
                <b-form-input disabled  type="text" id="model" v-model="puntuation.companies_id" placeholder=""></b-form-input>
              </b-form-group>
              <b-form-group class="col-md-6" label="ID del item" label-for="hora">
                <b-form-input disabled type="text" id="model" v-model="puntuation.items_id" placeholder=""></b-form-input>
              </b-form-group>
              <b-form-input hidden  type="text" id="model" v-model="puntuation.companies_id" placeholder=""></b-form-input>
              <b-form-input hidden type="text" id="model" v-model="puntuation.items_id" placeholder=""></b-form-input>


                </div>

              <div class="form-group text-right m-b-0">
                <button  type="submit" class="btn btn-primary">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" >
                  Cancelar
                </button>
              </div>

             
            </form>
          </div>
        </div>
      


      </div>

                  <div v-else-if=" !loading && classificationID > 3 " >
                    <DontExist />
                  </div>

                  <div v-else-if="!loading">
                    <DontExist />
                  </div>
                  <div v-else class="col-xl-12 text-center">
                    <div class="text-center">
                      <b-spinner variant="primary" label="Loading..."></b-spinner>
                    </div>
                  </div> 
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>